var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeliveryMan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "112px",
    height: "151px",
    viewBox: "0 0 112 151",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 24 Copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "--Book-pickup-flow",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "book-pickup---small-screen---thank-you",
    transform: "translate(-126.000000, -114.000000)",
    stroke: "#FFFFFF",
    strokeWidth: 2.6666666
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-24-Copy",
    transform: "translate(182.000000, 190.000000) scale(-1, 1) rotate(-180.000000) translate(-182.000000, -190.000000) translate(128.000000, 116.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "path340",
    points: "35 47.7368421 35 73 108 73 108 13 35 13 35 28.7894737"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "path342",
    points: "59 73 59 60 82 60 82 73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100,73 L93.0351556,85.2586714 C91.5063556,87.95 89.1173333,89.974 86.2989778,90.9662857 L72,96",
    id: "path344"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.532405,95 L17.8407045,87.6615957 C14.6758799,86.2679304 12.2191927,83.5862913 11.0615361,80.2600304 L0.54357145,50.0443783 C-1.1856438,45.0778391 1.34838135,39.6190261 6.19406952,37.8632174 L50,22",
    id: "path346"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 56,
    y1: 36,
    x2: 22,
    y2: 55,
    id: "path348"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 32,
    x2: 22,
    y2: -2.84217094e-14,
    id: "path350"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 82,
    y1: 13,
    x2: 82,
    y2: -8.52651283e-14,
    id: "path352"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72,116.333333 L72,107.602833 C72,105.08185 70.9993333,102.666 69.2180833,100.883483 L61.1886833,92.85535 C59.9999167,91.66785 58.3896667,91 56.70975,91 L49.29025,91 C47.6103333,91 46.0000833,91.66785 44.8113167,92.85535 L36.7819167,100.883483 C35.0006667,102.666 34,105.08185 34,107.602833 L34,116.333333 L34,132.166667 C34,140.909517 41.0892167,148 49.8333333,148 L56.1666667,148 C64.9107833,148 72,140.909517 72,132.166667 L72,122.666667",
    id: "path354"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 45,
    y1: 122,
    x2: 95,
    y2: 122,
    id: "path356"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 98,
    y1: 26,
    x2: 92,
    y2: 26,
    id: "path358"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 88,
    y1: 26,
    x2: 82,
    y2: 26,
    id: "path360"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveryMan);
export default __webpack_public_path__ + "static/media/delivery-man.dcd554d65c26637164ef73e89830c979.svg";
export { ForwardRef as ReactComponent };